module.exports = __webpack_public_path__ + "img/map-property-preview.19f73ca1.png";